/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable camelcase */

export const onlyNumbers = (str: string): string => {
  const nr_regex = /\D+/g;
  return String(str).replace(nr_regex, '');
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const FormatPriceInput = (price: any) => {
  let v = String(price).replace(/\D/g, '');
  v = `${(Number(v) / 100).toFixed(2)}`;
  v = v.replace('.', ',');
  v = v.replace(/(\d)(\d{3})(\d{3}),/g, '$1.$2.$3,');
  v = v.replace(/(\d)(\d{3}),/g, '$1.$2,');
  return v;
};

export const formatCurrencyBR = (value: string): string => {
  const number = value.replace(/\D/g, '');

  // Se nada foi digitado, retorna string vazia
  if (!number) return '';

  // Remove zeros à esquerda para evitar 0001 → 0,01
  const cleaned = number.replace(/^0+/, '') || '0';

  // Garante ao menos 3 dígitos
  const padded = cleaned.padStart(3, '0');

  const cents = padded.slice(-2);
  let reais = padded.slice(0, -2);

  reais = reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${reais},${cents}`;
};

export const parseCurrencyBRToFloat = (value: string): number => {
  if (!value) return 0;

  // Remove pontos de milhar e troca vírgula por ponto
  const normalized = value.replace(/\./g, '').replace(',', '.');

  return parseFloat(normalized);
};

export const FormatPrice = (price: any): any => {
  if (isNaN(price)) {
    return '0,00';
  }

  if (price == 0) {
    return '0,00';
  }
  return Number(price).toLocaleString('pt-br', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const FormatPriceEua = (price: any) => {
  let v = price.replace('.', '');
  v = v.replace(',', '.');
  return v;
};

export const FormatPhone = (phone: any, input = true) => {
  if (phone.length > 11 && input === false) {
    const regex = /^([0-9]{2})([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
    const str = String(phone)
      .replace(/[^0-9]/g, '')
      .slice(0, 13);
    return str.replace(regex, '($2) $3-$4');
  }
  if (phone.length > 11 && input === true) {
    const regex = /^([0-9]{2})([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
    const str = String(phone)
      .replace(/[^0-9]/g, '')
      .slice(0, 13);
    return str.replace(regex, '$1 - ($2) $3-$4');
  }
  const regex = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
  const str = String(phone)
    .replace(/[^0-9]/g, '')
    .slice(0, 11);
  return str.replace(regex, '($1) $2-$3');
};

export const FormatCpf = (cpf: any) => {
  // Remove qualquer caractere não numérico e limita a 11 dígitos

  const str = String(cpf)
    .replace(/[^0-9]/g, '')
    .slice(0, 11);

  if (str.length <= 3) return str;
  if (str.length <= 6) return `${str.slice(0, 3)}.${str.slice(3)}`;
  if (str.length <= 9)
    return `${str.slice(0, 3)}.${str.slice(3, 6)}.${str.slice(6)}`;

  // Formato final para 11 dígitos
  return `${str.slice(0, 3)}.${str.slice(3, 6)}.${str.slice(6, 9)}-${str.slice(
    9,
    11,
  )}`;
};

export const validateCpf = (data: string): boolean => {
  // Remove qualquer caractere que não seja número
  const cpf = data.replace(/\D/g, '');

  // Verifica se o CPF possui 11 dígitos e se não é uma sequência repetida
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  // Calcula os dígitos verificadores
  for (let t = 9; t < 11; t++) {
    let d = 0;
    for (let c = 0; c < t; c++) {
      d += Number(cpf[c]) * (t + 1 - c);
    }
    d = ((10 * d) % 11) % 10;
    if (Number(cpf[t]) !== d) {
      return false;
    }
  }

  return true;
};

export const FormatCnpj = (cpf: any) => {
  const regex = /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/;
  const str = String(cpf)
    .replace(/[^0-9]/g, '')
    .slice(0, 14);
  return str.replace(regex, '$1.$2.$3/$4-$5');
};

export const FormatCep = (zipcode: any) => {
  const regex = /^([0-9]{2})([0-9]{3})([0-9]{3})$/;
  const str = String(zipcode)
    .replace(/[^0-9]/g, '')
    .slice(0, 8);
  return str.replace(regex, '$1.$2-$3');
};

export const FormatDate = (date: any) => {
  const regex = /^([0-9]{2})([0-9]{2})([0-9]{4})$/;
  const str = String(date)
    .replace(/[^0-9]/g, '')
    .slice(0, 8);
  return str.replace(regex, '$1/$2/$3');
};

export const FormatDatePtBr = (date: string): any => {
  if (date) {
    return date.substring(0, 10).split('-').reverse().join('/');
  }
  return null;
};

export const FormatHours = (hours: string): any => {
  if (hours) {
    return hours.substring(0, 5);
  }
  return null;
};

export const FormatDateHoursPtBr = (date: string | number | Date): any => {
  if (date) {
    return new Date(date).toLocaleString('pt-br').replace(' ', ' - ');
  }
  return null;
};

export function isNumeric(value: any) {
  return (
    !isNaN(value) &&
    value !== null &&
    value !== '' &&
    typeof value !== 'boolean'
  );
}
